import { GiftReceiptRequestZodArraySchema } from "@redotech/redo-model/gift-receipt/gift-receipt-request";
import * as z from "zod/v4";

export const getGiftReceiptRequests = {
  name: "getGiftReceiptRequests" as const,
  input: z.object({
    limit: z.number().min(1).max(100).default(50).optional(),
    offset: z.number().min(0).default(0).optional(),
    pageContinue: z.string().optional(),
    sortKey: z.string().optional(),
    sortDirection: z.enum(["asc", "desc"]).optional(),
  }),

  output: z.object({
    requests: GiftReceiptRequestZodArraySchema,
    pageNext: z.string().nullish(),
  }),
};
